module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg load-bg",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"
  }, [_c('div', {
    staticClass: "login"
  }, [(_vm.token) ? _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.load.reference_number))])]) : _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v("Submit Load")])]), _vm._v(" "), (_vm.token) ? _c('form', {
    staticClass: "submit-load-details",
    attrs: {
      "role": "form"
    }
  }, [_c('weighbridge-details', {
    attrs: {
      "full-width": true,
      "stored-callback": _vm.showSuccess
    }
  })], 1) : (_vm.successful) ? _c('form', {
    staticClass: "submit-load-details",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "swal2-icon swal2-success swal2-animate-success-icon",
    staticStyle: {
      "display": "block",
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "swal2-success-circular-line-left",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-tip swal2-animate-success-line-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-long swal2-animate-success-line-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-ring"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-fix",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-circular-line-right",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "m-b-lg lead"
  }, [_vm._v("Load details succcessfully submitted.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info btn-lg m-b-sm",
    on: {
      "click": function($event) {
        _vm.successful = false
      }
    }
  }, [_vm._v("Submit Another Load")])])]) : _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Load Reference Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reference_number),
      expression: "reference_number"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Load Reference Number"
    },
    domProps: {
      "value": (_vm.reference_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reference_number = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleCheckReference,
      "max-width": true,
      "type": "success"
    }
  }, [_vm._v("Check Reference Number")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.login'
      },
      "href": "login.php"
    }
  }, [_vm._v("Account Login")])], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4d4b4040"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubmitLoad.vue
// module id = 995
// module chunks = 0